// Helper function to check if a string is a Plus Code
function isPlusCode(address: string): boolean {
  // Plus Code pattern: typically contains letters/numbers + "+" + letters/numbers
  // Examples: "2m73+hw3", "8FVC+2M", etc.
  const plusCodePattern = /^[A-Z0-9]{2,}\+[A-Z0-9]{2,}$/i;
  return plusCodePattern.test(address.trim());
}

// Helper function to remove Plus Code from an address string
function removePlusCode(address: string): string {
  // Pattern to match Plus Code at the start of string (with optional comma/space after)
  const plusCodePattern = /^[A-Z0-9]{2,}\+[A-Z0-9]{2,}[\s,]*/i;
  let cleaned = address.replace(plusCodePattern, '').trim();
  
  // Also remove Plus Code if it appears anywhere in the string (with commas/spaces around it)
  cleaned = cleaned.replace(/[\s,]*[A-Z0-9]{2,}\+[A-Z0-9]{2,}[\s,]*/gi, ' ').trim();
  
  // Clean up multiple spaces or commas
  cleaned = cleaned.replace(/[\s,]+/g, ' ').replace(/^[\s,]+|[\s,]+$/g, '');
  
  return cleaned || address; // Return original if cleaning removes everything
}

// Helper function to extract a proper address from geocoding results
function extractAddressFromResults(results: google.maps.GeocoderResult[]): string {
  // First, try to find a result with a proper formatted address (not a Plus Code)
  for (const result of results) {
    if (result.formatted_address) {
      const address = result.formatted_address;
      // If it's not just a Plus Code, clean it and return
      if (!isPlusCode(address)) {
        return removePlusCode(address);
      }
    }
  }

  // If all formatted_addresses are Plus Codes, try to use compound_code from plus_code
  // compound_code includes location info like "2m73+hw3, City, Country"
  for (const result of results) {
    if (result.plus_code?.compound_code) {
      // compound_code format: "Plus Code, Location, Country"
      // Extract the location part (skip the Plus Code itself)
      const parts = result.plus_code.compound_code.split(',');
      if (parts.length > 1) {
        // Return location info without the Plus Code
        const address = parts.slice(1).join(',').trim();
        return removePlusCode(address);
      }
    }
  }

  // Fallback: clean the first result's formatted_address
  const fallback = results[0]?.formatted_address || 'Unknown Location';
  return removePlusCode(fallback);
}

export function getAddressFromLatLng(lat: number, lng: number): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!window.google || !window.google.maps) {
      reject(new Error('Google Maps JS API not loaded'));
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat, lng };

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        console.log('results getAddressFromLatLng', results);
        const address = extractAddressFromResults(results);
        resolve(address);
      } else {
        reject(new Error('No address found or Geocoder failed: ' + status));
      }
    });
  });
}
